import { render, staticRenderFns } from "./LeadTripDetails.vue?vue&type=template&id=47637632&scoped=true&"
import script from "./LeadTripDetails.vue?vue&type=script&lang=js&"
export * from "./LeadTripDetails.vue?vue&type=script&lang=js&"
import style0 from "./LeadTripDetails.vue?vue&type=style&index=0&id=47637632&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47637632",
  null
  
)

export default component.exports